module.exports = __webpack_public_path__ + "static/media/bar-brewery-winery-5.381304e3.jpg";